import { render, staticRenderFns } from "./contentLabelCp.vue?vue&type=template&id=284a25d2&scoped=true"
import script from "./contentLabelCp.vue?vue&type=script&lang=js"
export * from "./contentLabelCp.vue?vue&type=script&lang=js"
import style0 from "./contentLabelCp.vue?vue&type=style&index=0&id=284a25d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a25d2",
  null
  
)

export default component.exports